import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import ApplicationTypeService from './applicationType.service'
import { createOptions } from '@/utils/arrayHelper'

export const useApplicationType = () => {
  const service = new ApplicationTypeService()
  const baseCrud = useCrud(API_RESOURCE.APPLICATION_TYPE, service)

  // const queryClient = useQueryClient()
  const useApplicationTypeOptions = ({ status = 'active', labelKey = 'name', valueKey = '_id', ...rest }) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status, ...rest } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status, ...rest } }),
      placeholderData: [],
      select: (data) => createOptions(data?.data, labelKey, valueKey),
    })
  }
  return {
    //Base CRUD
    useFetchAllApplicationTypes: baseCrud.useFetchAll,
    useFetchApplicationType: baseCrud.useFetchOne,
    useCreateApplicationType: baseCrud.useCreate,
    useUpdateApplicationType: baseCrud.useUpdate,
    useRemoveApplicationType: baseCrud.useRemove,
    useApplicationTypeOptions,
  }
}
